import styled from 'styled-components';

export const CommentWrapper = styled.div`
  padding: 24px 32px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.1);
  border-radius: 4px;
  margin-bottom: 16px;

  .personal-info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;

    .tutor-badge {
      margin-left: 8px;
      background-color: ${(props) => props.theme.colors.bgSubFooter};
      width: 16px;
      height: 16px;
      border-radius: 100%;
      display: inline-flex;
      justify-content: center;
      align-items: center;

      svg {
        stroke: ${(props) => props.theme.colors.white};
      }
    }

    .date {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-left: 16px;
      color: #646464;
    }

    .replies-number {
      margin-left: auto;
      text-align: right;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
      color: #8b8b8b;

      @media ${(props) => props.theme.device.tabletL} {
        width: 100%;
      }

      svg {
        margin-left: 4px;
        margin-top: -4px;
        stroke: #8b8b8b;
      }
    }
  }

  textarea {
    border: 1px solid #0056ac;
    border-radius: 4px;
    width: 100%;
    min-height: 120px;
    margin-bottom: 32px;
    padding: 8px;
  }

  .replies {
    margin: 52px 48px 32px 64px;

    .personal-info {
      column-gap: 8px;
    }

    .comment-body {
      margin-left: 48px; //avatar width + gap
    }

    @media ${(props) => props.theme.device.tabletL} {
      margin: 24px 0 0;
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    padding: 24px 16px;
  }
`;

export const RepliesToggle = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 18px;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: ${(props) => props.theme.colors.link};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;
